import React from "react"
import FirstNameField from "../fields/FirstNameField";
import EmailField from "../fields/EmailField";
import PasswordField from "../fields/PasswordField";
import LastNameField from "../fields/LastNameField";
import { apiCreateUser } from "../../api/api";
import ErrorField from "../fields/ErrorField";
import PasswordRule from "../fields/PasswordRule";

const MINIMUM_PASSWORD_LENGTH = 8;
const MINIMUM_NUMBERS = 1;
const MINIMUM_SPECIAL_CHARACTERS = 1;
const MINIMUM_UPPERCASE = 1;
const MINIMUM_LOWERCASE = 1;

class CreateAccountForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            firstName: '',
            lastName: '',
            email: '',
            password: '',
            confirmPassword: '',
            error: '',
            password_minimum_length_fulfilled: false,
            password_minimum_numbers_fulfilled: false,
            password_minimum_special_characters_fulfilled: false,
            password_minimum_uppercase_fulfilled: false,
            password_minimum_lowercase_fulfilled: false,
            passwords_match: false,
        };

        this.handleChangeFirst = this.handleChangeFirst.bind(this);
        this.handleChangeLast = this.handleChangeLast.bind(this);
        this.handleChangeEmail = this.handleChangeEmail.bind(this);
        this.handleChangePassword = this.handleChangePassword.bind(this);
        this.handleChangeConfirmPassword = this.handleChangeConfirmPassword.bind(this);
        this.handleCreateSubmit = this.handleCreateSubmit.bind(this);
    }

    handleChangeLast(event) {
        this.setState({
            ...this.state,
            lastName: event.target.value,
        });
    }

    handleChangeEmail(event) {
        this.setState({
            ...this.state,
            email: event.target.value,
        });
    }

    handleChangePassword(event) {
        this.setState({
            ...this.state,
            password: event.target.value,
        }, () => this.checkPasswordRules());
    }

    handleChangeConfirmPassword(event) {
        this.setState({
            ...this.state,
            confirmPassword: event.target.value,
        }, () => this.checkPasswordRules());
    }

    handleChangeFirst(event) {
        this.setState({
            ...this.state,
            firstName: event.target.value,
        });
    }

    handleCreateSubmit(event) {
        event.preventDefault();
        if (this.inputValid()) {
            const createResult = apiCreateUser(this.state.email, this.state.firstName + ' ' + this.state.lastName, this.state.password);

            createResult
            .then(res => {
                res.json().then(json => {
                    if (res.ok) {
                        this.setState({
                            ...this.state,
                            error: json.success,
                        });
                        window.location.href = '/create-success';
                    } else {
                        this.setState({
                            ...this.state,
                            error: json.description,
                        });
                    }
                });
            });
        } else {
            this.setState({
                ...this.state,
                error: 'Invalid input, please fill out all fields before continuing',
            });
        }
    }

    inputValid() {
        if (
            this.state.firstName !== '' &&
            this.state.lastName !== '' &&
            this.state.email !== '' &&
            this.state.password !== '' &&
            this.state.confirmPassword !== '' &&
            this.state.password === this.state.confirmPassword
        ) {
            return true;
        }
        return false;
    }

    checkPasswordRules() {
        this.setState({
            ...this.state,
            password_minimum_length_fulfilled: this.state.password.length >= MINIMUM_PASSWORD_LENGTH,
            password_minimum_numbers_fulfilled: this.state.password.match(/\d/g) ? this.state.password.match(/\d/g).length >= MINIMUM_NUMBERS : false,
            password_minimum_special_characters_fulfilled: this.state.password.match(/[^a-zA-Z0-9]/g) ? this.state.password.match(/[^a-zA-Z0-9]/g).length >= MINIMUM_SPECIAL_CHARACTERS : false,
            password_minimum_uppercase_fulfilled: this.state.password.match(/[A-Z]/g) ? this.state.password.match(/[A-Z]/g).length >= MINIMUM_UPPERCASE : false,
            password_minimum_lowercase_fulfilled: this.state.password.match(/[a-z]/g) ? this.state.password.match(/[a-z]/g).length >= MINIMUM_LOWERCASE : false,
            passwords_match: this.state.password === this.state.confirmPassword,
        });
    }

    render() {
        const enableSubmit = this.state.password_minimum_length_fulfilled &&
            this.state.password_minimum_numbers_fulfilled &&
            this.state.password_minimum_special_characters_fulfilled &&
            this.state.password_minimum_uppercase_fulfilled &&
            this.state.password_minimum_lowercase_fulfilled &&
            this.state.passwords_match;
        return (
            <div>
                <form onSubmit={this.handleCreateSubmit}>
                    <FirstNameField value={this.state.firstName} onChange={this.handleChangeFirst} />
                    <LastNameField value={this.state.lastName} onChange={this.handleChangeLast} />
                    <EmailField value={this.state.email} onChange={this.handleChangeEmail} />
                    <PasswordField value={this.state.password} onChange={this.handleChangePassword} />
                    <PasswordField value={this.state.confirmPassword} onChange={this.handleChangeConfirmPassword} confirm={true} />
                    <PasswordRule fulfilled={this.state.password_minimum_length_fulfilled} ruleText={`Password is at least ${MINIMUM_PASSWORD_LENGTH} characters long.`} />
                    <PasswordRule fulfilled={this.state.password_minimum_numbers_fulfilled} ruleText={`Password contains at least ${MINIMUM_NUMBERS} number(s).`} />
                    <PasswordRule fulfilled={this.state.password_minimum_special_characters_fulfilled} ruleText={`Password contains at least ${MINIMUM_SPECIAL_CHARACTERS} special character(s).`} />
                    <PasswordRule fulfilled={this.state.password_minimum_uppercase_fulfilled} ruleText={`Password contains at least ${MINIMUM_UPPERCASE} uppercase letter(s).`} />
                    <PasswordRule fulfilled={this.state.password_minimum_lowercase_fulfilled} ruleText={`Password contains at least ${MINIMUM_LOWERCASE} lowercase letter(s).`} />
                    <PasswordRule fulfilled={this.state.passwords_match} ruleText={`Passwords match.`} />
                    <ErrorField error={this.state.error} />
                    <input type="submit" value="Submit" disabled={!enableSubmit}/>
                </form>
            </div>
        )
    }
}

export default CreateAccountForm;
